import React from 'react'
import { ArrowRight } from 'lucide-react'
import { ProposalQuoteConditions } from '@/types/management.types'
import { formatCurrency } from '../../../utils/currency'

interface LeaseConditionsSectionProps {
  conditions?: ProposalQuoteConditions
}

// Mismo banner azul que GeneralData/VehicleData ("Datos generales"), con
// una fila por condición (ícono + label en negrita + valor en pesos) —
// mismo patrón visual que LeaseConditions.tsx (proposalAdjustments/), pero
// con el banner azul en vez de un texto plano, y sin depender de ese
// componente (compartido con el flujo interno de ajuste de propuestas).
export const LeaseConditionsSection: React.FC<LeaseConditionsSectionProps> = ({
  conditions,
}) => {
  if (!conditions) {
    return (
      <div className="bg-white border border-olr-grey-2 rounded-lg p-12 text-center text-olr-body">
        Aún no hay condiciones de arrendamiento disponibles.
      </div>
    )
  }

  const items: { label: string; value: string }[] = [
    { label: 'Monto del arrendamiento', value: conditions.leaseAmount },
    { label: 'Seguro anual', value: conditions.insurance },
    { label: 'Total pago inicial', value: conditions.totalInitialAmount },
    { label: 'Comisión por apertura', value: conditions.openingFee },
    { label: 'Valor residual sin IVA', value: conditions.residualValueNoTax },
    { label: 'Renta mensual sin IVA', value: conditions.monthlyRentNoTax },
    { label: 'Descuento mensual', value: conditions.monthlyDiscount },
    {
      label: 'Total de renta con descuento',
      value: conditions.totalRentWithDiscount,
    },
    { label: 'IVA de renta', value: conditions.rentTax },
    { label: 'Fondo de reserva', value: conditions.reserveFund },
    {
      label: 'Total renta mensual con IVA',
      value: conditions.totalRentWithTax,
    },
  ]

  return (
    <div className="w-full bg-white rounded-lg">
      <div className="bg-[#E4EFFF] px-6 py-3">
        <h2 className="text-sm font-semibold text-[#000000] uppercase tracking-wide text-center">
          Condiciones del arrendamiento
        </h2>
      </div>

      <div className="p-6">
        <div className="border border-olr-primary rounded-lg p-5">
          {items.map(item => (
            <div
              key={item.label}
              className="flex justify-between items-center py-2"
            >
              <div className="flex items-center gap-3 text-gray-900 font-bold">
                <ArrowRight size={16} className="text-olr-primary shrink-0" />
                {item.label}
              </div>
              <div className="font-medium text-gray-800">
                {formatCurrency(item.value)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default LeaseConditionsSection
